import qs from 'qs'
import axios from '../config/axios.js'
import { getApiUrl } from '../config/baseUrl.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
const BASE_URL = getApiUrl('/api/college_manage')
export const fileServer = {
  getfile: (params) => {
    return axios.get(`${BASE_URL}/file/getPath`, { params: params }).then(res => res.data);
  },
  getcheckData: (params) => {
    return axios.get(`${BASE_URL}/study/upload/query`, { params: params }).then(res => res.data);
  }
};


// WEBPACK FOOTER //
// ./src/api/server/upload.js